var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.label)?_c('span',[_vm._v(" "+_vm._s(_vm.label))]):_vm._e(),_c('span',{ref:"span-amount",class:_vm.amountClass},[_vm._v(_vm._s((_vm.amount/_vm.gb_to_bytes).toPrecision(6)/1)+" GB")])])}
var staticRenderFns = []

export { render, staticRenderFns }